import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-request-section',
  templateUrl: './create-request-section.component.html',
  styleUrls: ['./create-request-section.component.css']
})
export class CreateRequestSectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
